import { useFormContext, Controller } from "react-hook-form";
import Checkbox from "../input/Checkbox";

interface FormCheckboxProps {
  name: string;
  label?: string;
  className?: string;
  disabled?: boolean;
}

/**
 * RHF-bound wrapper around the Checkbox primitive. Keeps tri-state +
 * a11y from `Checkbox` and exposes a single boolean to the form.
 */
export function FormCheckbox({
  name,
  label,
  className,
  disabled = false,
}: FormCheckboxProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = errors[name];

  return (
    <div className={className}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Checkbox
            checked={!!value}
            onChange={onChange}
            label={label}
            disabled={disabled}
          />
        )}
      />
      {error && (
        <p className="mt-1.5 text-xs text-[var(--destructive)]">
          {error.message as string}
        </p>
      )}
    </div>
  );
}
